{
  "team.title": "Team",
  "team.subtitle": "Everyone at 404 Creative, their roles and what they can do.",
  "team.tabs.label": "Team views",
  "team.tabs.members": "Members",
  "team.tabs.departments": "Departments",
  "team.tabs.roles": "Roles",
  "team.tabs.activity": "Activity",
  "team.loadError": "We could not load the team.",
  "team.loadMore": "Load more",
  "team.loadingMore": "Loading…",
  "team.search": "Search members",
  "team.filter.label": "Filter by status",
  "team.filter.all": "All",
  "team.filter.active": "Active",
  "team.filter.invited": "Invited",
  "team.filter.deactivated": "Deactivated",
  "team.columns.member": "Member",
  "team.columns.role": "Role",
  "team.columns.department": "Department",
  "team.columns.status": "Status",
  "team.columns.joined": "Joined",
  "team.status.active": "Active",
  "team.status.invited": "Invited",
  "team.status.invitedExpires": "Invited · expires {when}",
  "team.status.invitationExpired": "Invitation expired",
  "team.status.deactivated": "Deactivated",
  "team.department.none": "No department",
  "team.empty.title": "No one here yet",
  "team.empty.body": "Invite the first member to start working together.",
  "team.noResults.title": "No matching members",
  "team.noResults.body": "Try another name, email or status.",
  "team.noResults.clear": "Clear filters",
  "team.member.panel": "Team member",
  "team.member.properties": "Details",
  "team.member.role": "Role",
  "team.member.department": "Department",
  "team.member.title": "Job title",
  "team.member.titlePlaceholder": "Add a job title",
  "team.member.noTitle": "No job title",
  "team.member.email": "Email",
  "team.member.joined": "Joined",
  "team.member.invitedOn": "Invited on",
  "team.member.deactivatedOn": "Deactivated on",
  "team.member.invitedBy": "Invited by",
  "team.member.unknownInviter": "Someone who has left",
  "team.member.expires": "Link expires",
  "team.member.notFound.title": "This member is not on the team",
  "team.member.notFound.body": "They may have been removed, or the link is incomplete.",
  "team.member.roleChanged": "{name} is now {role}.",
  "team.member.grantOwner.title": "Make {name} an owner?",
  "team.member.grantOwner.body": "Owners have full control of 404 OS, including over other owners. Only an owner can take this role away again.",
  "team.member.grantOwner.confirm": "Make owner",
  "team.rules.viewOnly": "Only people who manage the team can change this.",
  "team.rules.self": "You cannot change your own role or deactivate your own account.",
  "team.rules.ownerOnly": "Only an owner can change another owner.",
  "team.rules.lastOwner": "This is the only active owner. Make someone else an owner first.",
  "team.rules.moreReach": "This person can do things you cannot, so you cannot change them.",
  "team.permissions.heading": "Permissions",
  "team.permissions.hint": "What the {role} role gives, with any exceptions for this person. Changes apply to them alone.",
  "team.permissions.ownerFixed": "An owner always has every permission.",
  "team.permissions.self": "You cannot change your own permissions.",
  "team.permissions.added": "Added",
  "team.permissions.removed": "Removed",
  "team.permissions.fixed": "Only the owner role gives this.",
  "team.permissions.ownerOnly": "Only the owner gives or takes away access to money.",
  "team.permissions.impliedBy": "Comes with {permission}.",
  "team.permissions.notHeld": "You can only give permissions you have yourself.",
  "team.permissions.reset": "Reset to role",
  "team.permissions.unsaved": "Unsaved changes",
  "team.permissions.discard": "Discard",
  "team.permissions.save": "Save",
  "team.permissions.saving": "Saving…",
  "team.permissions.saved": "{name}'s permissions were saved.",
  "team.permissions.loadError": "We could not load the permissions.",
  "team.permissions.confirm.title": "Change {name}'s permissions?",
  "team.permissions.confirm.adds": "Gives them: {list}.",
  "team.permissions.confirm.removes": "Takes away: {list}.",
  "team.permissions.exceptions": "Exceptions to the role: {added, plural, =0 {none added} one {# permission added} other {# permissions added}}, {removed, plural, =0 {none removed} other {# removed}}",
  "team.invitation.heading": "Invitation",
  "team.invitation.link": "Invitation link",
  "team.invitation.linkHidden": "For security, an invitation link is shown only once. Resend the invitation to get a new link; the old one stops working.",
  "team.invitation.newLinkTitle": "New link ready",
  "team.invitation.newLinkBody": "Copy it and send it to {name}. The previous link no longer works.",
  "team.invitation.resend": "Resend invitation",
  "team.invitation.resending": "Resending…",
  "team.invitation.resent": "A new invitation link for {name} is ready.",
  "team.invitation.revoke": "Revoke invitation",
  "team.invitation.revoking": "Revoking…",
  "team.invitation.revoked": "The invitation to {name} was revoked.",
  "team.invitation.revokeConfirm.title": "Revoke the invitation to {name}?",
  "team.invitation.revokeConfirm.body": "The link stops working and {email} leaves the team list. You can invite them again later.",
  "team.account.heading": "Account",
  "team.account.deactivateHint": "Deactivating signs them out everywhere at once and blocks sign-in. Their work and history stay.",
  "team.account.reactivateHint": "This account is deactivated. Reactivate it to let them sign in again.",
  "team.account.deactivate": "Deactivate account",
  "team.account.deactivating": "Deactivating…",
  "team.account.deactivated": "{name}'s account was deactivated.",
  "team.account.deactivateConfirm.title": "Deactivate {name}'s account?",
  "team.account.deactivateConfirm.body": "They are signed out of every device immediately and can no longer sign in. Their tasks, comments and history stay as they are. You can reactivate the account at any time.",
  "team.account.reactivate": "Reactivate account",
  "team.account.reactivating": "Reactivating…",
  "team.account.reactivated": "{name}'s account was reactivated.",
  "team.account.reactivateConfirm.title": "Reactivate {name}'s account?",
  "team.account.reactivateConfirm.body": "They can sign in again with their existing password, with the same role as before.",
  "team.errors.lastOwner": "The team needs at least one active owner. Make someone else an owner first.",
  "team.errors.self": "You cannot change your own role or deactivate your own account.",
  "team.errors.forbidden": "You do not have permission to do that. Your permissions were refreshed.",
  "team.errors.conflict": "Someone else changed this member in the meantime, so it was refreshed. Try again.",
  "team.errors.stale": "This changed in the meantime, so the team was refreshed.",
  "team.errors.invitationGone": "This invitation was already accepted or withdrawn.",
  "team.invite.action": "Invite member",
  "team.invite.title": "Invite a team member",
  "team.invite.description": "They get a link to set their name and password and join 404 OS.",
  "team.invite.email": "Work email",
  "team.invite.emailPlaceholder": "name@404creativee.com",
  "team.invite.name": "Name",
  "team.invite.nameHint": "Optional. They can change it when they join.",
  "team.invite.role": "Role",
  "team.invite.department": "Department",
  "team.invite.submit": "Create invitation",
  "team.invite.sending": "Creating…",
  "team.invite.errors.email": "Enter a valid email address.",
  "team.invite.errors.emailTaken": "Someone on the team already uses this email.",
  "team.invite.errors.forbidden": "Only an owner can invite another owner.",
  "team.invite.errors.nameLength": "Use 150 characters or fewer.",
  "team.invite.success.heading": "Invitation ready",
  "team.invite.success.title": "Invitation created",
  "team.invite.success.body": "Send this link to {email} so they can join.",
  "team.invite.success.note": "Send this link yourself. It works once and expires in 7 days.",
  "team.invite.another": "Invite another",
  "team.invite.done": "Done",
  "team.departments.title": "Departments",
  "team.departments.description": "Group the team by what they do. A department can be deleted once nobody is in it.",
  "team.departments.readOnly": "How the team is grouped. Admins and owners manage departments.",
  "team.departments.loadError": "We could not load the departments.",
  "team.departments.memberCount": "{count, plural, =0 {No members} one {# member} other {# members}}",
  "team.departments.new": "New department",
  "team.departments.add": "Add",
  "team.departments.save": "Save",
  "team.departments.created": "{name} department added.",
  "team.departments.rename": "Rename",
  "team.departments.renameLabel": "Rename {name}",
  "team.departments.delete": "Delete {name}",
  "team.departments.deleteBlocked": "Move everyone out of this department before deleting it.",
  "team.departments.deleting": "Deleting…",
  "team.departments.deleted": "{name} department deleted.",
  "team.departments.deleteConfirm.title": "Delete the {name} department?",
  "team.departments.deleteConfirm.body": "Nobody is in it, so nothing else changes. Its name stays in the activity log.",
  "team.departments.deleteConfirm.confirm": "Delete department",
  "team.departments.empty.title": "No departments yet",
  "team.departments.empty.body": "Departments group the team, such as Design or Development.",
  "team.departments.errors.name": "Write a name.",
  "team.departments.errors.nameTaken": "Another department already has this name.",
  "team.departments.errors.notEmpty": "Move everyone out of this department before deleting it.",
  "team.activity.description": "Every change to the team and the client list, newest first.",
  "team.activity.loadError": "We could not load the activity.",
  "team.activity.empty.title": "Nothing has happened yet",
  "team.activity.empty.body": "Invitations, role changes and client updates will show up here.",
  "team.activity.system": "404 OS",
  "team.activity.member.invited": "{actor} invited {target} to join as {role}",
  "team.activity.invitation.resent": "{actor} sent {target} a new invitation link",
  "team.activity.invitation.revoked": "{actor} revoked the invitation to {target}",
  "team.activity.invitation.accepted": "{target} accepted the invitation and joined the team",
  "team.activity.member.roleChanged": "{actor} changed {target}'s role from {from} to {to}",
  "team.activity.member.departmentChanged": "{actor} moved {target} to the {to} department",
  "team.activity.member.departmentCleared": "{actor} removed {target} from the {from} department",
  "team.activity.member.titleChanged": "{actor} changed {target}'s job title to {to}",
  "team.activity.member.titleCleared": "{actor} cleared {target}'s job title",
  "team.activity.member.updated": "{actor} updated {target}'s details",
  "team.activity.member.deactivated": "{actor} deactivated {target}'s account",
  "team.activity.member.reactivated": "{actor} reactivated {target}'s account",
  "team.activity.member.permissionsGiven": "{actor} gave {target} {added}",
  "team.activity.member.permissionsTaken": "{actor} took {removed} away from {target}",
  "team.activity.member.permissionsSwapped": "{actor} gave {target} {added} and took away {removed}",
  "team.activity.member.permissionsReset": "{actor} put {target} back on what their role gives",
  "team.activity.member.permissionsChanged": "{actor} changed {target}'s permissions",
  "team.activity.department.created": "{actor} created the {target} department",
  "team.activity.department.renamed": "{actor} renamed the {from} department to {to}",
  "team.activity.department.deleted": "{actor} deleted the {target} department",
  "team.activity.profile.updated": "{actor} updated their profile",
  "team.activity.email.changed": "{actor} changed their email",
  "team.activity.password.changed": "{actor} changed their password",
  "team.activity.password.reset": "{actor} reset their password",
  "team.activity.client.created": "{actor} added the client {target}",
  "team.activity.client.updated": "{actor} updated the details of {target}",
  "team.activity.client.archived": "{actor} archived the client {target}",
  "team.activity.client.restored": "{actor} restored the client {target}",
  "team.activity.contact.added": "{actor} added {contact} as a contact at {target}",
  "team.activity.contact.updated": "{actor} updated {contact}, a contact at {target}",
  "team.activity.contact.removed": "{actor} removed {contact} from the contacts at {target}",
  "team.activity.unknown": "{actor} made a change ({action})",
  "roles.title": "Roles and permissions",
  "roles.explainer": "Each person has one role, and the role decides what they can see and do across 404 OS. Inside a project, people are also its lead, a contributor or a viewer.",
  "roles.loadError": "We could not load the roles.",
  "roles.yourRole": "Your role",
  "roles.noPermissions": "No agency-wide permissions: sees only the projects they are added to.",
  "roles.matrix.caption": "What each role can do",
  "roles.matrix.permission": "Permission",
  "roles.matrix.included": "Included",
  "roles.matrix.notIncluded": "Not included",
  "roles.group.team": "Team",
  "roles.group.projects": "Projects",
  "roles.group.tasks": "Tasks",
  "roles.group.clients": "Clients",
  "roles.group.time": "Time",
  "roles.group.leads": "Leads",
  "roles.group.billing": "Billing",
  "roles.group.tickets": "Support",
  "roles.owner.summary": "Full control of 404 OS, including other owners.",
  "roles.admin.summary": "Runs the team, the clients and every project.",
  "roles.pm.summary": "Creates and runs projects, and manages clients.",
  "roles.finance.summary": "Follows every project and client without changing the work.",
  "roles.member.summary": "Sees clients; works on the projects they join.",
  "roles.contractor.summary": "Sees only the projects they are added to.",
  "permission.team.view.label": "See the team",
  "permission.team.view.description": "Open the team list, departments and roles.",
  "permission.team.manage.label": "Manage the team",
  "permission.team.manage.description": "Invite people, change roles, deactivate accounts.",
  "permission.team.manage_owners.label": "Manage owners",
  "permission.team.manage_owners.description": "Make someone an owner, or change an owner's role or account.",
  "permission.departments.manage.label": "Manage departments",
  "permission.departments.manage.description": "Add, rename and delete departments.",
  "permission.audit.view.label": "See activity",
  "permission.audit.view.description": "Read the log of changes to the team and clients.",
  "permission.projects.create.label": "Create projects",
  "permission.projects.create.description": "Start new projects and lead them.",
  "permission.projects.view_all.label": "See every project",
  "permission.projects.view_all.description": "Open any project, not only their own.",
  "permission.projects.manage_all.label": "Manage every project",
  "permission.projects.manage_all.description": "Change any project's details, members and tasks.",
  "permission.clients.view.label": "See clients",
  "permission.clients.view.description": "Open the client list, contacts and their projects.",
  "permission.clients.manage.label": "Manage clients",
  "permission.clients.manage.description": "Add and edit clients and contacts, archive clients.",
  "permission.time.view_all.label": "See everyone's time",
  "permission.time.view_all.description": "Open anyone's timesheet and the agency-wide time reports.",
  "permission.leads.manage.label": "Work the lead inbox",
  "permission.leads.manage.description": "Sync website leads, answer and qualify them, and convert them into clients and projects.",
  "permission.billing.view.label": "See billing",
  "permission.billing.view.description": "Open proposals, invoices, payments, expenses and the money reports.",
  "permission.billing.manage.label": "Manage billing",
  "permission.billing.manage.description": "Send proposals, issue proformas and payment requests, record payments, credit notes and expenses.",
  "permission.tickets.view.label": "See support",
  "permission.tickets.view.description": "Open the client support inbox and read the conversation.",
  "permission.tickets.manage.label": "Work support",
  "permission.tickets.manage.description": "Claim, reply, resolve, reassign, and convert a support request into a task.",
  "invitation.documentTitle": "Join the team",
  "invitation.title": "You're invited to join 404 OS",
  "invitation.subtitle": "{inviter} invited you to the 404 Creative team. Check your name and choose a password.",
  "invitation.subtitleNoInviter": "You were invited to the 404 Creative team. Check your name and choose a password.",
  "invitation.email": "Email",
  "invitation.role": "Role",
  "invitation.invitedBy": "Invited by",
  "invitation.name": "Your name",
  "invitation.password": "Password",
  "invitation.passwordHint": "{count, plural, one {At least # character} other {At least # characters}}",
  "invitation.join": "Join 404 OS",
  "invitation.joining": "Joining…",
  "invitation.welcome": "Welcome to 404 OS, {name}.",
  "invitation.errors.name": "Write your name.",
  "invitation.errors.nameLength": "Use 150 characters or fewer.",
  "invitation.errors.password": "Use at least 10 characters.",
  "invitation.loadError": "We could not open this invitation.",
  "invitation.invalid.title": "This invitation is no longer valid",
  "invitation.invalid.body": "It may have been used already or withdrawn. Ask whoever invited you for a new link.",
  "invitation.expired.title": "This invitation has expired",
  "invitation.expired.body": "Ask whoever invited you for a new link.",
  "invitation.goToSignIn": "Go to sign in",
  "profile.title": "Profile and settings",
  "profile.subtitle": "Your details, appearance, language, email and password.",
  "profile.section.profile": "Profile",
  "profile.section.profileHint": "How you appear to the team, and the language 404 OS speaks to you in.",
  "profile.section.password": "Password",
  "profile.section.passwordHint": "Changing it signs you out on every other device.",
  "profile.section.account": "Account",
  "profile.section.accountHint": "Set by the people who manage the team.",
  "profile.name": "Name",
  "profile.jobTitle": "Job title",
  "profile.jobTitleHint": "Set by an admin in Team.",
  "profile.jobTitleEmpty": "Not set yet",
  "profile.picture.upload": "Upload a picture",
  "profile.picture.change": "Change picture",
  "profile.picture.uploading": "Uploading…",
  "profile.picture.remove": "Remove",
  "profile.picture.hint": "A clear photo of your face. We crop it to a square.",
  "profile.picture.saved": "Picture updated",
  "profile.picture.removed": "Picture removed",
  "profile.picture.errors.type": "Choose a PNG, JPEG or WebP picture.",
  "profile.picture.errors.tooLarge": "That picture is too large. Try a smaller one.",
  "profile.picture.errors.generic": "We could not save the picture. Try again.",
  "profile.language": "Language",
  "profile.language.ar": "العربية",
  "profile.language.ar.hint": "Right to left, Arabic digits",
  "profile.language.en": "English",
  "profile.language.en.hint": "Left to right, Latin digits",
  "profile.languageNote": "Your language follows you to every device you sign in on.",
  "profile.save": "Save changes",
  "profile.saving": "Saving…",
  "profile.saved": "Your profile was saved.",
  "profile.errors.name": "Write your name.",
  "profile.errors.nameLength": "Use 150 characters or fewer.",
  "profile.password.current": "Current password",
  "profile.password.new": "New password",
  "profile.password.confirm": "Confirm new password",
  "profile.password.hint": "{count, plural, one {At least # character} other {At least # characters}}",
  "profile.password.note": "Your other devices will be signed out.",
  "profile.password.submit": "Change password",
  "profile.password.changing": "Changing…",
  "profile.password.changed": "Password changed. Your other devices were signed out.",
  "profile.password.errors.current": "Enter your current password.",
  "profile.password.errors.wrong": "This is not your current password.",
  "profile.password.errors.length": "Use at least 10 characters.",
  "profile.password.errors.mismatch": "The two passwords do not match.",
  "profile.section.email": "Email",
  "profile.section.emailHint": "The address you sign in with and get 404 OS emails at.",
  "profile.email.current": "You sign in with",
  "profile.email.new": "New email",
  "profile.email.password": "Current password",
  "profile.email.note": "Your password stays the same.",
  "profile.email.submit": "Change email",
  "profile.email.changing": "Changing…",
  "profile.email.changed": "Email changed. Sign in with {email} from now on.",
  "profile.email.errors.invalid": "Enter a valid email address.",
  "profile.email.errors.password": "Enter your current password.",
  "profile.email.errors.wrong": "This is not your current password.",
  "profile.email.errors.taken": "Someone on 404 OS already uses this email.",
  "profile.account.email": "Email",
  "profile.account.role": "Role",
  "profile.account.department": "Department",
  "profile.account.memberSince": "Member since",
  "profile.account.permissions": "What your role lets you do",
  "profile.account.managedBy": "To change your role or department, ask an admin or an owner.",
  "clients.subtitle": "The companies you work with and the people you talk to there.",
  "clients.new": "New client",
  "clients.loadError": "We could not load the clients.",
  "clients.loadMore": "Load more",
  "clients.loadingMore": "Loading…",
  "clients.loading": "Loading…",
  "clients.search": "Search clients or contacts",
  "clients.filter.label": "Filter by status",
  "clients.filter.active": "Active",
  "clients.filter.archived": "Archived",
  "clients.filter.all": "All",
  "clients.status.active": "Active",
  "clients.status.archived": "Archived",
  "clients.columns.client": "Client",
  "clients.columns.location": "Country",
  "clients.columns.contact": "Primary contact",
  "clients.columns.contacts": "Contacts",
  "clients.columns.created": "Added",
  "clients.noContact": "No contact yet",
  "clients.noCountry": "Not set",
  "clients.empty.title": "No clients yet",
  "clients.empty.body": "Add the first client to link projects and keep their contacts in one place.",
  "clients.empty.bodyReadOnly": "Clients that project managers add will show up here.",
  "clients.noResults.title": "No matching clients",
  "clients.noResults.body": "Try another name, contact or status.",
  "clients.noResults.clear": "Clear filters",
  "clients.notFound.title": "Client not found",
  "clients.notFound.body": "It may have been removed, or the link is incomplete.",
  "clients.detailLoadError": "We could not load this client.",
  "clients.backToList": "Go to clients",
  "clients.tabs.label": "Client views",
  "clients.tabs.overview": "Overview",
  "clients.tabs.projects": "Projects",
  "clients.prefers.ar": "Prefers Arabic",
  "clients.prefers.en": "Prefers English",
  "clients.language.ar": "Arabic",
  "clients.language.ar.hint": "Messages and documents in Arabic",
  "clients.language.en": "English",
  "clients.language.en.hint": "Messages and documents in English",
  "clients.edit": "Edit",
  "clients.archive": "Archive",
  "clients.archiving": "Archiving…",
  "clients.archived": "{name} was archived.",
  "clients.archiveConfirm.title": "Archive {name}?",
  "clients.archiveConfirm.body": "It leaves the active list and can no longer be picked for new projects. Its projects, contacts and history stay, and you can restore it at any time.",
  "clients.restore": "Restore",
  "clients.restoring": "Restoring…",
  "clients.restored": "{name} is active again.",
  "clients.restoreConfirm.title": "Restore {name}?",
  "clients.restoreConfirm.body": "It returns to the active list and can be picked for projects again.",
  "clients.archivedNotice.title": "This client is archived",
  "clients.archivedNotice.body": "Restore it to edit its details or contacts.",
  "clients.archivedNotice.bodyReadOnly": "Its details are kept for reference.",
  "clients.details.title": "Details",
  "clients.details.legalName": "Legal name",
  "clients.details.country": "Country",
  "clients.details.currency": "Currency",
  "clients.details.language": "Language",
  "clients.details.website": "Website",
  "clients.details.created": "Added",
  "clients.details.notes": "Notes",
  "clients.details.none": "Not set",
  "clients.errors.nameTaken": "An active client already has this name.",
  "clients.errors.archived": "This client is archived. Restore it first.",
  "clients.errors.conflict": "Someone else changed this client in the meantime, so it was refreshed. Try again.",
  "clients.errors.forbidden": "You do not have permission to change clients.",
  "clients.errors.contactGone": "This contact no longer exists.",
  "clients.form.newTitle": "New client",
  "clients.form.newDescription": "A company you work for. You can add the people you talk to there next.",
  "clients.form.editTitle": "Edit client",
  "clients.form.name": "Name",
  "clients.form.namePlaceholder": "Beit El Qahwa",
  "clients.form.legalName": "Legal name",
  "clients.form.optional": "Optional",
  "clients.form.country": "Country",
  "clients.form.otherCountry": "Another country…",
  "clients.form.countryCode": "Country code",
  "clients.form.countryCodeHint": "Two letters, such as SA, QA or GB.",
  "clients.form.currency": "Currency",
  "clients.form.currencyOption": "{code} · {name}",
  "clients.form.language": "Preferred language",
  "clients.form.website": "Website",
  "clients.form.websitePlaceholder": "example.com",
  "clients.form.notes": "Notes",
  "clients.form.notesPlaceholder": "How they like to work, who decides, anything the team should know.",
  "clients.form.create": "Create client",
  "clients.form.save": "Save changes",
  "clients.form.saving": "Saving…",
  "clients.form.created": "{name} was added.",
  "clients.form.saved": "Client details saved.",
  "clients.form.errors.name": "Use at least 2 characters.",
  "clients.form.errors.tooLong": "This is too long.",
  "clients.form.errors.country": "Use a two-letter country code, such as SA.",
  "clients.projects.project": "Project",
  "clients.projects.status": "Status",
  "clients.projects.lead": "Lead",
  "clients.projects.progress": "Progress",
  "clients.projects.noLead": "No lead",
  "clients.projects.loadError": "We could not load this client's projects.",
  "clients.projects.empty.title": "No projects yet",
  "clients.projects.empty.body": "Projects for this client will show up here.",
  "contact.title": "Contacts",
  "contact.add": "Add contact",
  "contact.added": "{name} was added.",
  "contact.saved": "{name} was saved.",
  "contact.edit": "Edit",
  "contact.editLabel": "Edit {name}",
  "contact.remove": "Remove",
  "contact.removeLabel": "Remove {name}",
  "contact.removing": "Removing…",
  "contact.removed": "{name} was removed.",
  "contact.removeConfirm.title": "Remove {name}?",
  "contact.removeConfirm.body": "They are removed from this client's contacts. This cannot be undone.",
  "contact.removeConfirm.bodyPrimary": "They are the primary contact, so the next contact becomes the primary one. This cannot be undone.",
  "contact.primary": "Primary",
  "contact.noMethods": "No email or phone yet",
  "contact.whatsappWith": "WhatsApp {name}",
  "contact.empty.title": "No contacts yet",
  "contact.empty.body": "Add the people you talk to at this client. The first one becomes the primary contact.",
  "contact.form.newTitle": "Add a contact",
  "contact.form.newDescription": "Someone you talk to at {client}.",
  "contact.form.editTitle": "Edit contact",
  "contact.form.name": "Name",
  "contact.form.title": "Job title",
  "contact.form.titlePlaceholder": "Marketing manager",
  "contact.form.email": "Email",
  "contact.form.phone": "Phone",
  "contact.form.whatsapp": "WhatsApp",
  "contact.form.phoneHint": "Include the country code. A number without one is read as a number in {country}.",
  "contact.form.language": "Preferred language",
  "contact.form.primary": "Primary contact",
  "contact.form.primaryHint": "The first person to reach at this client. Only one contact can be primary.",
  "contact.form.notes": "Notes",
  "contact.form.add": "Add contact",
  "contact.form.save": "Save changes",
  "contact.form.saving": "Saving…",
  "contact.form.errors.name": "Write a name.",
  "contact.form.errors.email": "Enter a valid email address.",
  "contact.form.errors.phone": "This number is too long.",
  "contact.form.errors.phoneInvalid": "Enter a phone number with its country code, such as +20 100 123 4567.",
  "contact.form.errors.tooLong": "This is too long.",
  "profile.section.appearance": "Appearance",
  "profile.section.appearanceHint": "Light, dark, or whatever this device is set to.",
  "profile.appearance.note": "Applies at once and is kept on this device.",
  "team.tiles.active": "Active members",
  "team.tiles.deactivated": "{count, plural, =0 {No one deactivated} one {# deactivated} other {# deactivated}}",
  "team.tiles.invited": "Pending invitations",
  "team.tiles.invitedCaption": "Waiting to join",
  "team.tiles.unplaced": "{count, plural, =0 {Everyone is placed} one {# without a department} other {# without a department}}",
  "team.tiles.roles": "Roles in use",
  "team.tiles.rolesCaption": "See what each role can do",
  "team.departments.split.title": "How the team is spread",
  "team.departments.split.body": "Active and invited people in each department",
  "clients.tiles.active": "Active clients",
  "clients.tiles.archived": "{count, plural, =0 {None archived} one {# archived} other {# archived}}",
  "clients.tiles.projects": "Running projects",
  "clients.tiles.withWork": "{count, plural, =0 {No client has work running} one {For # client} other {For # clients}}",
  "clients.tiles.contacts": "Contacts",
  "clients.tiles.contactsCaption": "People you talk to",
  "clients.tiles.countries": "Countries",
  "clients.tiles.countriesCaption": "Where your clients are",
  "clients.columns.projects": "Projects",
  "clients.projects.none": "No projects",
  "clients.projects.more": "+{count}",
  "clients.work.title": "Work for this client",
  "clients.work.all": "All projects",
  "clients.work.running": "Running projects",
  "clients.work.openTasks": "Open tasks",
  "clients.work.overdue": "Overdue",
  "clients.work.noneRunning": "Nothing is running for this client right now.",
  "team.invite.success.emailedTitle": "Invitation sent",
  "team.invite.success.emailedBody": "We emailed the invitation to {email}. You can also copy the link below and send it on WhatsApp.",
  "team.invite.success.emailedNote": "The link works once and expires in 7 days.",
  "team.invitation.resentEmailed": "A fresh invitation was emailed to {name}.",
  "roles.hr.summary": "Runs people operations: employee records, attendance, time off, payroll, reviews and hiring.",
  "roles.group.hr": "People",
  "roles.group.payroll": "Payroll",
  "roles.group.performance": "Performance",
  "roles.group.recruitment": "Hiring",
  "permission.hr.view.label": "See employee records",
  "permission.hr.view.description": "Open everyone's employee record, attendance and time off. Salaries are not included.",
  "permission.hr.manage.label": "Manage employee records",
  "permission.hr.manage.description": "Edit records, read sealed identifiers, correct attendance and decide requests as HR.",
  "permission.payroll.view.label": "See payroll",
  "permission.payroll.view.description": "See salaries, payroll months and everyone's payslips.",
  "permission.payroll.manage.label": "Run payroll",
  "permission.payroll.manage.description": "Change pay, add bonuses and deductions, run, lock and pay the month.",
  "permission.performance.manage.label": "Run reviews",
  "permission.performance.manage.description": "Start review cycles, calibrate ratings and read every review.",
  "permission.recruitment.view.label": "See hiring",
  "permission.recruitment.view.description": "Open job openings and candidates.",
  "permission.recruitment.manage.label": "Manage hiring",
  "permission.recruitment.manage.description": "Publish openings, move candidates, schedule interviews and send offers.",
  "permission.tasks.create.label": "Create tasks",
  "permission.tasks.create.description": "Add tasks and subtasks, turn tickets into tasks and make tasks repeat."
}
